
import React from 'react';

type ReactMarkdownComponentProps = {
  children: React.ReactNode;
  className?: string;
};

export const EnhancedTable: React.FC<ReactMarkdownComponentProps> = ({ children }) => (
  <div className="overflow-x-auto my-3 rounded-lg border border-white/10 shadow-lg">
    <table className="min-w-full divide-y divide-gray-700 bg-background/40 backdrop-blur-sm">
      {children}
    </table>
  </div>
);

export const EnhancedThead: React.FC<ReactMarkdownComponentProps> = ({ children }) => (
  <thead className="bg-gradient-to-r from-primary/10 to-primary/5">
    {children}
  </thead>
);

export const EnhancedTh: React.FC<ReactMarkdownComponentProps> = ({ children }) => (
  <th className="px-2 py-1.5 text-left text-xs font-medium text-foreground uppercase tracking-wider border-b border-white/10">
    {children}
  </th>
);

export const EnhancedTd: React.FC<ReactMarkdownComponentProps> = ({ children }) => (
  <td className="px-2 py-1.5 text-xs border-b border-white/5 hover:bg-white/5 transition-colors">
    {children}
  </td>
);

export const EnhancedTbody: React.FC<ReactMarkdownComponentProps> = ({ children }) => (
  <tbody className="divide-y divide-gray-700/50">{children}</tbody>
);

export const EnhancedTr: React.FC<ReactMarkdownComponentProps> = ({ children }) => (
  <tr className="hover:bg-white/5 transition-colors duration-200">{children}</tr>
);
